export const config = {
  modelName: 'ScholarshipFaqPage',
} as const;
